import productBillingApi from '../../api/productBilling'
import productConfigOptionsApi from '../../api/productConfigOptions'

export default {
    namespaced: true,
    state: () => ({
        orderconfiguration: {
            supportedQuantity: {
                min: 1,
                max: 100
            }
        },
        billingcyclelist: ['Monthly', 'Semi-annually', 'Annually'],
        co: [],
        pricing: {},
        currency: {},
    }),
    mutations:
    {
        SET_CONFIGURATION(state, val) {
            state.orderconfiguration = val
        },
        SET_BILLINGLIST(state, val) {
            state.billingcyclelist = val
        },
        SET_CO(state, val)
        {
            state.co = val
        },
        SET_PRICING(state, val)
        {
            state.pricing = val
        },
        SET_CURRENCY(state, val)
        {
            state.currency = val
        }
    },
    actions:
    {
        loadBillingCycles(context, payload) {
            return new Promise((resolve) => {
                const api = new productBillingApi(payload.axios, payload.pid);
                let BillingSet = false
                api.getBilling().then((response) => {
                    let billingcycles = [];
                    context.commit("SET_PRICING", response.data.pricing);
                    context.commit("SET_CURRENCY", response.data.currency);
                    for (const [value, text] of Object.entries(response.data.pricing.cycles)) {
                        billingcycles.push({ value, text })
                        if (!BillingSet) {
                            context.commit("Choices/SET_BILLING", value, { root: true });
                            BillingSet = true;
                        }
                    }
                  
                    context.commit("SET_BILLINGLIST", billingcycles);
                    resolve(response)
                });
            })
        },
        loadCO(context, payload) {
            return new Promise((resolve) => {
                const api = new productConfigOptionsApi(payload.axios, payload.pid, payload.billing);
                
                api.getPrices().then((response) => {

                    context.commit("SET_CO", response.data);
                    resolve(response)
                });
            })
        }
    }
}